export default __webpack_public_path__ + "static/media/forest_alpha01.144eafad.jpeg";